<template>
    <div>
        <header-tool-bar @toggleDrawer="drawer = !drawer"></header-tool-bar>
        <v-content class="page-content">
            <slot />
        </v-content>
    </div>
</template>

<script>
    import sidebar from '../components/common/sidebar'
    import headerToolBar from '../components/common/headerToolBar'
    export default {
        name: "TopHeader",
        components: {
            sidebar,
            headerToolBar
        },
        data () {
            return {
                drawer: true
            }
        }
    }
</script>

<style scoped>

</style>